import { CircleArrowLeft } from 'lucide-react';
import { Link } from '@tanstack/react-router';

import { FormSubmissionsTable } from './form-submissions-table';

export function FormSubmissionsPage() {
  return (
    <div className='min-h-screen bg-white p-10'>
      <Link to='/dashboard' className='flex w-max items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>Form Submissions</h2>
      </Link>
      <p className='mt-2 text-sm text-muted-foreground'>
        Every website form submission, with its Portal and CRM sync status.
        Failed syncs can be retried or marked as skipped.
      </p>
      <div className='mt-4 border-t pt-8'>
        <FormSubmissionsTable />
      </div>
    </div>
  );
}
